// removed by extract-text-webpack-plugin
module.exports = {"twoFAContent":"twoFAContent","twoFaContent":"twoFAContent","twoFAHeader":"twoFAHeader","twoFaHeader":"twoFAHeader","twoFAButtonDiv":"twoFAButtonDiv","twoFaButtonDiv":"twoFAButtonDiv","subTitle":"subTitle","infoPanel":"infoPanel","boldtext":"boldtext","buttonDiv":"buttonDiv","disableFormButton":"disableFormButton","authKeyText":"authKeyText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/twoFA/style.scss
// module id = 156
// module chunks = 0